import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ZoomPanelService } from '../../../../core/outputs/annotation/annotation-shared/zoom-panel/zoom-panel.service';
import { NumberIndex } from '../../../../cross-team-shared/types/misc';
import { ImageAnnotationLayerType } from '../../../../team-apis/otterdam/outputs/image-annotation-output';
import { contentInjectorToken } from '../../annotation-shared/abstract-annotation-output-component';
import { AnnotationState2D } from '../../annotation-shared/state/root/annotation-state-2d';
import { ImageAnnotationStore } from '../state/image-annotation-store';

@Component({
  selector: 'h3-image-annotation-layout',
  templateUrl: './image-annotation-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ImageAnnotationLayoutComponent {
  @Input({ required: true }) state!: AnnotationState2D;

  activeLayerType$: Observable<ImageAnnotationLayerType>;
  protected contentInjector = inject(contentInjectorToken);

  constructor(store: ImageAnnotationStore, zoomPanelService: ZoomPanelService) {
    this.activeLayerType$ = store('activeLayerIndex').$.pipe(
      switchMap((index) => store('layers')(index as NumberIndex)('type').$),
    );

    zoomPanelService.setUpZoomPanelSubscription();
  }
}
